import {Directive} from '@angular/core';

@Directive({
  selector: `ui-bullet-chart-title, [ui-bullet-chart-title], [uiBulletChartTitle]`,
  host: {
    class: 'ui-bullet-chart-title mat-h3'
  }
})
export class BulletChartTitleDirective {}
